import type { IntlKey } from 'locales';
import { FC, useCallback, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import styled from 'styled-components';
import { pascalCaseToWords } from 'utils/string';

const StyledIcon = styled.i`
  background-color: inherit !important;
`;

const StyledDropdownToggle = styled(DropdownToggle)`
  background-color: inherit !important;
  color: inherit !important;
`;

interface Props {
  className?: string;
  availableValues: readonly string[];
  value: string;
  onChange(value: string): void;
}
export const CompactRegionSelector: FC<Props> = ({ value, availableValues, onChange }) => {
  const { formatMessage } = useIntl();
  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const toggle = useCallback(() => {
    setIsDropdownOpened(!isDropdownOpened);
  }, [isDropdownOpened]);

  const handleRegionSelection = useCallback(
    (region: string) => {
      if (onChange) {
        logAnalytics.trackEvent('Discover', 'Select region', region);
        onChange(region);
      }
    },
    [onChange],
  );
  return (
    <>
      <div className="d-flex flex-row flex-nowrap align-items-center justify-content-end me-2">
        <Dropdown
          show={isDropdownOpened}
          onToggle={toggle}
          drop="down"
          className="h-100"
          onClick={toggle}
          data-e2e="region-selector-container"
        >
          <StyledDropdownToggle caret className="border-0 btn btn-xl btn-icon-ext btn-flat-secondary">
            <span className="">
              <StyledIcon className="pb-1 me-2 icon icon-md">public</StyledIcon>
              <span className="" data-e2e="selected-region">
                {formatMessage({ id: `discover.region.${value}` as IntlKey, defaultMessage: pascalCaseToWords(value) })}
              </span>
            </span>
          </StyledDropdownToggle>
          <DropdownMenu className="w-100">
            {availableValues
              .filter(item => item !== value)
              .map(item => (
                <DropdownItem key={item} onClick={() => handleRegionSelection(item)}>
                  {formatMessage({ id: `discover.region.${item}` as IntlKey, defaultMessage: pascalCaseToWords(item) })}
                </DropdownItem>
              ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  );
};

CompactRegionSelector.displayName = 'CompactRegionSelector';
